import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const LEGAL_I18N_NAMESPACE = '@mc/legal'

export const i18nInstance = registerI18nResources({
  namespace: LEGAL_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
